import { render, staticRenderFns } from "./SubmitSetting.vue?vue&type=template&id=15ca9b20&scoped=true&"
import script from "./SubmitSetting.vue?vue&type=script&lang=js&"
export * from "./SubmitSetting.vue?vue&type=script&lang=js&"
import style0 from "./SubmitSetting.vue?vue&type=style&index=0&id=15ca9b20&prod&lang=less&scoped=true&"
import style1 from "./SubmitSetting.vue?vue&type=style&index=1&id=15ca9b20&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca9b20",
  null
  
)

export default component.exports